var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5284_265732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.051 7.051L20.949 16.949M23 12C23 15.866 19.866 19 16 19C12.134 19 9 15.866 9 12C9 8.13401 12.134 5 16 5C19.866 5 23 8.13401 23 12Z",
    stroke: "#FF644C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.248 16V7.6H35.26V8.764H30.652V11.26H34.744V12.46H30.652V16H29.248ZM38.965 8.92L37.525 13.312H40.429L38.965 8.92ZM41.317 16L40.789 14.428H37.165L36.649 16H35.233L38.137 7.6H39.865L42.769 16H41.317ZM44.1425 16V7.6H45.5465V16H44.1425ZM49.4372 14.824H54.1172V16H48.0332V7.6H49.4372V14.824ZM55.6855 16V7.6H61.8895V8.752H57.0535V11.188H61.2775V12.352H57.0535V14.848H62.0095V16H55.6855ZM67.0357 16H63.7597V7.6H67.0837C68.3397 7.6 69.2717 7.932 69.8797 8.596C70.4877 9.252 70.7917 10.304 70.7917 11.752C70.7917 13.192 70.4797 14.26 69.8557 14.956C69.2397 15.652 68.2997 16 67.0357 16ZM65.1637 14.836H66.9517C67.3197 14.836 67.6557 14.788 67.9597 14.692C68.2637 14.588 68.5197 14.416 68.7277 14.176C68.9357 13.936 69.0957 13.624 69.2077 13.24C69.3277 12.848 69.3877 12.364 69.3877 11.788C69.3877 11.236 69.3357 10.768 69.2317 10.384C69.1277 10 68.9757 9.688 68.7757 9.448C68.5837 9.208 68.3437 9.036 68.0557 8.932C67.7677 8.82 67.4397 8.764 67.0717 8.764H65.1637V14.836Z",
    fill: "#FF6F67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12C79.5 18.3513 74.3513 23.5 68 23.5H12C5.64872 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "#FF644C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5284_265732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedBadge);
export default __webpack_public_path__ + "static/media/failedBadge.3f033af6341caf8b4f07b827ad735c08.svg";
export { ForwardRef as ReactComponent };